import { MutationTree } from 'vuex'
import { ISearchState } from './types'

const mutations: MutationTree<ISearchState> = {
  reset(state) {
    state.results = []
    state.lookup = ''
  },

  lookup(state, lookup) {
    state.lookup = lookup
  },

  results(state, results) {
    state.results = results
  },
  
  setAccessToken(state, accessToken) {
    state.accessToken = accessToken
  },

  setFundSearchApiEndpoint(state, fundSearchApiEndpoint) {
    state.fundSearchApiEndpoint = fundSearchApiEndpoint
  },

  setSelectedResultIndex(state, newIndex) {
    state.selectedResultIndex = newIndex;
  },

  setCanResultPanelOpen(state, opened) {
    state.canResultPanelOpen = opened
  },
  
  setCacheSuffix(state, cacheSuffix) {
    state.cacheSuffix = cacheSuffix
  },
}

export default mutations

